export default __webpack_public_path__ + "static/media/admin-message-info.1ed7f346.svg";